import { Size } from '@/types';

export const getAreaOfSize = ({ width, height }: Size) => width * height;
